module.exports = __webpack_public_path__ + "img/receiver.af498e31.png";